export const aboutData = {
  title: "About Me",
  subtitle: "Passionate game developer with expertise in rapid prototyping and building internal tools",
  
  content: {
    whoIAm: {
      title: "Who I Am",
      paragraphs: [
        "I'm a Game Developer with 6 years of experience, creating games, interactive experiences, and tools across XR, mobile, web and PC. Skilled in Unity, Unreal Engine, and various tech stacks, I’ve contributed to both published titles and rapid prototypes in commercial and experimental projects.",
        "I thrive in fast-paced environments and enjoy solving tough problems. I'm quick to learn new tools, adapt to different stacks, and switch between projects with ease. I specialize in rapid prototyping and building internal tools that streamline workflows and boost team efficiency.",
        "Above all, I’m passionate about crafting engaging, meaningful experiences, whether for players or teammates. I love pushing creative and technical boundaries, and I’m always looking for new ways to grow and contribute through interactive development."    
      ]
    }
  },
  
  personalInfo: [
    { icon: 'User', label: 'Name', value: 'Sarah Chun' },
    { icon: 'MapPin', label: 'Location', value: 'Richmond, BC, Canada' },
    { icon: 'Calendar', label: 'Experience', value: '6 Years' },
    { icon: 'Mail', label: 'Email', value: 'sarah.chun.0119@gmail.com' }
  ]
}; 